module.exports = __webpack_public_path__ + "img/Line.81e27b55.svg";